import * as React from 'react';
import { Col, Row, Alert } from 'antd';
import { Prompt } from 'react-router';

import { observer } from 'mobx-react';
import { TextView } from 'src/core/ui/text.view';
import { HeaderView } from 'src/app/shared/header.view';
import { ContextService } from 'src/core/services/context.service';
import { DocumentTemplateCategoryEditorController } from 'src/app/general/document-template-categories/parts/document-template-category-editor.controller';
import { EmailTargetEditorController } from 'src/app/general/email-document-template/parts/email-target-editor.controller';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';

interface IEmailDocumentTemplateFormView extends ComponentViewProps<IEmailDocumentTemplateItem> {
	title: string;
	model: IEmailDocumentTemplateItem;
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	setBusy(isBusy: boolean);
	contextService: ContextService;
	isAdmin: boolean;
}

@observer
export class EmailDocumentTemplateFormView extends React.Component<IEmailDocumentTemplateFormView, {}> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const { model } = this.props;

		const subjects = (model as any).dynamicProperties['subject'];
		const htmls = (model as any).dynamicProperties['html'];

		const array: TabLanguageModel[] = [
			{
				title: 'Subject',
				dynamicProperties: subjects,
				rows: 1
			},
			{
				title: 'Body',
				dynamicProperties: htmls,
				rows: 1
			}
		];


		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} xl={{ offset: 4, span: 16 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChange}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<div className="card card-borderless">
							<Row gutter={16}>
								<Col xs={8}>
									<DocumentTemplateCategoryEditorController
										value={model.categoryId}
										mode={this.props.isAdmin ? this.props.mode : 'display'}
										onChange={(newValue) => {
											this.props.model.categoryId = newValue.id;
										}}
										label="Category"
										required={true}
										setBusy={this.props.setBusy}
									/>
								</Col>
								<Col xs={8}>
									<TextView
										required
										label="Name"
										value={this.props.model.name}
										onChanged={newVal => model.name = newVal}
										onGetErrorMessage={() => this.props.model.validate(true, 'name')}
										mode={this.props.isAdmin ? this.props.mode : 'display'}
									/>
								</Col>
								<Col xs={8}>
									<EmailTargetEditorController
										required
										label="Email target"
										setBusy={this.props.setBusy}
										value={this.props.model.target}
										onChanged={newVal => model.target = newVal}
										onGetErrorMessage={() => this.props.model.validate(true, 'target')}
										mode={this.props.isAdmin ? this.props.mode : 'display'}
									/>
								</Col>
							</Row>
							<Row >
								<Col xs={24}>
									<TabLanguageController
										model={model}
										dynamicProperties={array}
										mode={this.props.mode}
										setBusy={this.props.setBusy}
										isRichTextBox={[false, true]}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<Alert
										message="Subject cannot be more than 250 characters"
										type="warning"
										showIcon={true}
									/>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/form/email-document-template-form.view.tsx